// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/RobotoMono-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/RobotoMono-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/RobotoMono-Bold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media parameters */
/* Colors */
/* Fonts */
@font-face {
  font-family: "Roboto Mono";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-display: swap;
}
@font-face {
  font-family: "Roboto Mono";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-display: swap;
}
@font-face {
  font-family: "Roboto Mono";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-display: swap;
}
* {
  box-sizing: border-box;
}

html,
body {
  font-size: 16px;
  line-height: 110%;
  font-family: "Roboto Mono", "Arial", monospace;
  font-weight: 400;
  font-style: normal;
  color: #333333;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
  scrollbar-width: thin;
  background-color: #FFFFFF;
}

main {
  flex-grow: 1;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
  object-fit: cover;
}

#root {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/variables.sass","webpack://./src/assets/styles/fonts.sass","webpack://./src/assets/styles/base.sass","webpack://./src/assets/styles/mixins.sass"],"names":[],"mappings":"AAAA,qBAAA;AASA,WAAA;AAWA,UAAA;ACpBA;EACI,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;EACA,kBAAA;ACIJ;ADDA;EACI,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;EACA,kBAAA;ACGJ;ADAA;EACI,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,4DAAA;EACA,kBAAA;ACEJ;AAnBA;EACI,sBAAA;AAqBJ;;AAnBA;;ECAI,eAAA;EACA,iBAAA;EDEA,8CFWS;EEVT,gBAAA;EACA,kBAAA;EACA,cFFS;EEIT,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EAEA,yBFZS;AEiCb;;AAnBA;EACI,YAAA;AAsBJ;;AApBA;EACI,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAuBJ;;AArBA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AAwBJ","sourcesContent":["/* Media parameters */\r\n$mobile-max: 768px\r\n$tablet-max: 1210px\r\n$desktop-max: 1440px\r\n\r\n// Отступы от краев экрана\r\n$mobile-offset: 8px\r\n$desktop-offset: 64px\r\n\r\n/* Colors */\r\n$base-white: #FFFFFF\r\n$base-black: #333333\r\n$base-shadow: #0500FF40\r\n$accent: #8000FF\r\n$accent-darken: #6000BF\r\n$link: #007AFF\r\n$error: #D60056\r\n// Также отвечает и за disabled\r\n$placeholder: #33333360\r\n\r\n/* Fonts */\r\n$fm-primary: 'Roboto Mono', 'Arial', monospace","@font-face \r\n    font-family: \"Roboto Mono\"\r\n    font-weight: 400\r\n    font-style: normal\r\n    src: url(\"../fonts/RobotoMono-Regular.woff2\") format(\"woff2\")\r\n    font-display: swap\r\n\r\n\r\n@font-face \r\n    font-family: \"Roboto Mono\"\r\n    font-weight: 500\r\n    font-style: normal\r\n    src: url(\"../fonts/RobotoMono-Medium.woff2\") format(\"woff2\")\r\n    font-display: swap\r\n\r\n\r\n@font-face \r\n    font-family: \"Roboto Mono\"\r\n    font-weight: 700\r\n    font-style: normal\r\n    src: url(\"../fonts/RobotoMono-Bold.woff2\") format(\"woff2\")\r\n    font-display: swap\r\n","@use \"./variables\" as *\r\n@use \"./mixins\" as mix\r\n@use \"./fonts\"\r\n\r\n*\r\n    box-sizing: border-box\r\n\r\nhtml,\r\nbody\r\n    @include mix.text-2\r\n    font-family: $fm-primary\r\n    font-weight: 400\r\n    font-style: normal\r\n    color: $base-black\r\n\r\n    margin: 0\r\n    padding: 0\r\n    width: 100%\r\n    height: 100%\r\n    display: flex\r\n    scrollbar-width: thin\r\n\r\n    background-color: $base-white\r\n\r\nmain\r\n    flex-grow: 1\r\n\r\nimg\r\n    display: block\r\n    max-width: 100%\r\n    height: auto\r\n    object-fit: cover\r\n\r\n#root\r\n    flex-grow: 1\r\n    display: flex\r\n    flex-direction: column\r\n","@use \"./variables\" as *\r\n\r\n@mixin text-1\r\n    font-size: 20px\r\n    line-height: 120%\r\n\r\n@mixin text-2\r\n    font-size: 16px\r\n    line-height: 110%\r\n\r\n@mixin text-3\r\n    font-size: 12px\r\n    line-height: 110%\r\n\r\n@mixin container\r\n    max-width: $desktop-max\r\n    margin: 0 auto\r\n    width: calc(100vw - $desktop-offset * 2)\r\n\r\n    @media (max-width: $mobile-max)\r\n        width: calc(100vw - $mobile-offset * 2)\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
